// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"583":"f84c1bab","872":"1942a375"}[chunkId] + ".chunk.css";
};